/* NEON BLINK — interazioni landing: drawer, carosello recensioni, back-to-top */
(function () {
  'use strict';

  /* ── Drawer mobile ── */
  var drawer = document.getElementById('drawer');
  var burger = document.querySelector('[data-drawer-open]');

  function openDrawer() {
    drawer.hidden = false;
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.hidden = true;
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (burger && drawer) {
    burger.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  }

  /* ── Carosello recensioni ──
     Scroll nativo con snap: le frecce e i dot spostano di una card,
     lo scroll manuale (swipe) aggiorna il dot attivo. */
  var carousel = document.querySelector('[data-carousel]');

  if (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(track.children);
    var dotsWrap = carousel.querySelector('[data-carousel-dots]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    var index = 0;

    var dots = slides.map(function (_, i) {
      var b = document.createElement('button');
      b.className = 'carousel__dot';
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to review ' + (i + 1));
      b.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(b);
      return b;
    });

    function goTo(i) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      var target = slides[index];
      // centra la slide nel track invece di usare scrollIntoView (che muove la pagina)
      var left = target.offsetLeft - (track.clientWidth - target.clientWidth) / 2;
      track.scrollTo({ left: left, behavior: 'smooth' });
      sync();
    }

    function nearestIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft + s.clientWidth / 2 - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function sync() {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      prev.disabled = index === 0;
      next.disabled = index === slides.length - 1;
    }

    prev.addEventListener('click', function () { goTo(index - 1); });
    next.addEventListener('click', function () { goTo(index + 1); });

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { index = nearestIndex(); sync(); }, 90);
    }, { passive: true });

    sync();
  }

  /* ── Back to top ── */
  var toTop = document.querySelector('[data-to-top]');
  if (toTop) {
    window.addEventListener('scroll', function () {
      toTop.classList.toggle('is-visible', window.scrollY > 500);
    }, { passive: true });
    toTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ── Anno nel footer ── */
  var year = document.querySelector('[data-year]');
  if (year) year.textContent = new Date().getFullYear();
})();

/* ── PAGINA PRODOTTO: galleria, fasce quantità, before/after, barra sticky ── */
(function () {
  'use strict';

  /* Galleria: scroll snap + frecce + dot + miniature */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.thumb'));
    var dotsWrap = gallery.querySelector('[data-gallery-dots]');
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var i = 0;

    var dots = slides.map(function (_, n) {
      var b = document.createElement('button');
      b.className = 'gallery__dot';
      b.type = 'button';
      b.setAttribute('aria-label', 'Image ' + (n + 1));
      b.addEventListener('click', function () { go(n); });
      dotsWrap.appendChild(b);
      return b;
    });

    function go(n) {
      i = Math.max(0, Math.min(n, slides.length - 1));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      sync();
    }
    function sync() {
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      prev.disabled = i === 0;
      next.disabled = i === slides.length - 1;
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    prev.addEventListener('click', function () { go(i - 1); });
    next.addEventListener('click', function () { go(i + 1); });

    var gt;
    track.addEventListener('scroll', function () {
      clearTimeout(gt);
      gt = setTimeout(function () {
        i = Math.round(track.scrollLeft / track.clientWidth);
        sync();
      }, 90);
    }, { passive: true });

    sync();
  }

  /* Fasce quantità: selezione + prezzo aggiornato ovunque */
  var tiers = document.querySelector('[data-tiers]');
  if (tiers) {
    var cards = Array.prototype.slice.call(tiers.querySelectorAll('.tier'));
    var now = document.querySelector('[data-price-now]');
    var was = document.querySelector('[data-price-was]');
    var sNow = document.querySelector('[data-sticky-now]');
    var sWas = document.querySelector('[data-sticky-was]');

    cards.forEach(function (card) {
      card.querySelector('input').addEventListener('change', function (e) {
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        var n = e.target.dataset.now;
        var w = e.target.dataset.was;
        if (now) now.textContent = n;
        if (was) was.textContent = w;
        if (sNow) sNow.textContent = n;
        if (sWas) sWas.textContent = w;
      });
    });
  }

  /* Before / after: trascinamento della maniglia */
  var ba = document.querySelector('[data-ba]');
  if (ba) {
    var after = ba.querySelector('[data-ba-after]');
    var handle = ba.querySelector('[data-ba-handle]');
    var dragging = false;

    function setPos(clientX) {
      var r = ba.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      after.style.width = pct + '%';
      handle.style.left = pct + '%';
    }

    function start(e) { dragging = true; e.preventDefault(); }
    function move(e) {
      if (!dragging) return;
      setPos(e.touches ? e.touches[0].clientX : e.clientX);
    }
    function end() { dragging = false; }

    handle.addEventListener('mousedown', start);
    handle.addEventListener('touchstart', start, { passive: false });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('mouseup', end);
    window.addEventListener('touchend', end);

    // click diretto sull'immagine
    ba.addEventListener('click', function (e) {
      if (e.target !== handle && !handle.contains(e.target)) setPos(e.clientX);
    });

    // frecce da tastiera
    handle.addEventListener('keydown', function (e) {
      var cur = parseFloat(after.style.width) || 50;
      if (e.key === 'ArrowLeft')  { cur -= 4; e.preventDefault(); }
      if (e.key === 'ArrowRight') { cur += 4; e.preventDefault(); }
      cur = Math.max(0, Math.min(100, cur));
      after.style.width = cur + '%';
      handle.style.left = cur + '%';
    });
  }

  /* Barra sticky: compare quando il bottone principale è uscito dallo schermo */
  var bar = document.querySelector('[data-stickybar]');
  var mainCta = document.querySelector('.buybox [data-add-to-cart]');
  if (bar && mainCta) {
    function updateBar() {
      bar.classList.toggle('is-visible', mainCta.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    updateBar();
  }
})();

/* ── CARRELLO A SCOMPARSA ──────────────────────────────────────────
   Due modalità:
   · su Shopify (window.EYESBLINK.variantId valorizzato) usa il carrello
     vero: /cart.js per leggere, /cart/update.js per scrivere
   · altrove (anteprima statica) tiene lo stato in localStorage

   Due scelte volute:
   1. il prezzo barrato è sempre il "prezzo di confronto" per la quantità
      scelta (99.90 × pezzi), non il prezzo pieno di listino: così il
      carrello racconta lo stesso risparmio della pagina prodotto
   2. "Add to Cart" IMPOSTA la quantità dell'offerta scelta, non la somma
      a quella già presente: le fasce sono offerte alternative           */
(function () {
  'use strict';

  var drawer = document.getElementById('cart');
  if (!drawer) return;

  var cfg = window.EYESBLINK || {};
  var onShopify = !!(window.Shopify && cfg.variantId);

  var itemsBox = drawer.querySelector('[data-cart-items]');
  var totalEl  = drawer.querySelector('[data-cart-total]');
  var timerEl  = drawer.querySelector('[data-cart-timer]');
  var counters = document.querySelectorAll('[data-cart-count]');

  var KEY = 'eyesblink:cart';
  var DEADLINE_KEY = 'eyesblink:deadline';
  var MINUTES = 15;

  var DEMO = {
    title: 'Eyes Blink™ – RGB Headlight Eyes',
    list: 99.90,
    tiers: { 1: 39.90, 2: 69.90, 3: 89.90 },
    unitOver3: 29.97
  };

  /* ---- valuta: su Shopify segue quella del carrello (€, £, $…) ---- */
  var fmt = null;
  function useCurrency(code) {
    if (!code) return;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: code
      });
    } catch (e) { fmt = null; }
  }
  function money(n) {
    n = Math.round(n * 100) / 100;
    return fmt ? fmt.format(n) : '$' + n.toFixed(2);
  }

  function shopifyPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function updates(qty) {
    var u = {};
    u[cfg.variantId] = qty;
    return { updates: u };
  }

  /* prezzo di confronto della variante, letto una volta sola */
  var compareCache = {};
  function compareAtFor(item) {
    if (item.handle in compareCache) return Promise.resolve(compareCache[item.handle]);
    return fetch('/products/' + item.handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var v = prod.variants.filter(function (x) { return x.id === item.variant_id; })[0] || prod.variants[0];
        var c = v && v.compare_at_price ? v.compare_at_price : null;
        compareCache[item.handle] = c;
        return c;
      })
      .catch(function () { compareCache[item.handle] = null; return null; });
  }

  var api = onShopify ? {
    get: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          useCurrency(c.currency);
          var it = c.items[0];
          if (!it) return { qty: 0 };
          return compareAtFor(it).then(function (cmp) {
            return {
              qty: it.quantity,
              title: it.product_title,
              image: it.image,
              now: it.final_line_price / 100,
              was: (cmp ? cmp * it.quantity : it.original_line_price) / 100
            };
          });
        });
    },
    setTo:  function (qty) { return shopifyPost('/cart/update.js', updates(qty)); },
    setQty: function (state, qty) { return shopifyPost('/cart/update.js', updates(qty)); },
    clear:  function () { return shopifyPost('/cart/update.js', updates(0)); }
  } : {
    get: function () {
      var raw;
      try { raw = JSON.parse(localStorage.getItem(KEY)); } catch (e) { raw = null; }
      if (!raw || !raw.qty) return Promise.resolve({ qty: 0 });
      var q = raw.qty;
      return Promise.resolve({
        qty: q,
        title: raw.title,
        image: raw.image,
        now: DEMO.tiers[q] || Math.round(DEMO.unitOver3 * q * 100) / 100,
        was: DEMO.list * q
      });
    },
    save: function (raw) {
      if (raw && raw.qty > 0) localStorage.setItem(KEY, JSON.stringify(raw));
      else localStorage.removeItem(KEY);
      return Promise.resolve();
    },
    setTo: function (qty) {
      var img = document.querySelector('.gallery__img');
      var title = document.querySelector('.buybox__title');
      return api.save({
        qty: qty,
        image: img ? img.getAttribute('src') : '',
        title: title ? title.textContent.trim() : DEMO.title
      });
    },
    setQty: function (state, qty) {
      return api.save({ qty: qty, image: state.image, title: state.title });
    },
    clear: function () { return api.save(null); }
  };

  /* ---- disegno ---- */
  var current = { qty: 0 };

  function render() {
    return api.get().then(function (state) {
      current = state;
      counters.forEach(function (c) { c.textContent = state.qty || 0; });

      if (!state.qty) {
        itemsBox.innerHTML = '<p class="cart__empty">Your cart is empty.</p>';
        totalEl.textContent = money(0);
        return;
      }

      var saved = state.was - state.now;

      itemsBox.innerHTML =
        '<article class="citem">' +
          '<img class="citem__img" src="' + state.image + '" alt="">' +
          '<div class="citem__body">' +
            '<h3 class="citem__title">' + state.title + '</h3>' +
            '<div class="citem__row">' +
              '<span class="qty">' +
                '<button type="button" data-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<span>' + state.qty + '</span>' +
                '<button type="button" data-qty="1" aria-label="Increase quantity">+</button>' +
              '</span>' +
              '<span class="citem__prices">' +
                (saved > 0.005 ? '<s class="citem__was">' + money(state.was) + '</s>' : '') +
                '<b class="citem__now">' + money(state.now) + '</b>' +
                (saved > 0.005 ? '<span class="citem__save">(You Save ' + money(saved) + ')</span>' : '') +
              '</span>' +
            '</div>' +
          '</div>' +
          '<button class="citem__del" data-cart-remove aria-label="Remove item">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/></svg>' +
          '</button>' +
        '</article>';

      totalEl.textContent = money(state.now);
    });
  }

  /* ---- apertura / chiusura ---- */
  function open() {
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    startTimer();
  }
  function close() {
    drawer.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function () { render(); open(); });
  });
  drawer.querySelectorAll('[data-cart-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  /* ---- quantità e rimozione dentro al carrello ---- */
  itemsBox.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty]');
    if (step) {
      var next = Math.max(0, current.qty + Number(step.dataset.qty));
      api.setQty(current, next).then(render);
      return;
    }
    if (e.target.closest('[data-cart-remove]')) api.clear().then(render);
  });

  /* ---- Add to Cart: imposta la quantità dell'offerta scelta ---- */
  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var picked = document.querySelector('[data-tiers] input:checked');
      btn.disabled = true;
      api.setTo(Number(picked ? picked.value : 1))
        .then(render)
        .then(open)
        .catch(function (err) { console.error('Cart error:', err); })
        .then(function () { btn.disabled = false; });
    });
  });

  /* ---- timer dello sconto ---- */
  var tick;
  function startTimer() {
    if (tick || !timerEl) return;
    var deadline = Number(sessionStorage.getItem(DEADLINE_KEY));
    if (!deadline || deadline < Date.now() - MINUTES * 60000) {
      deadline = Date.now() + MINUTES * 60000;
      sessionStorage.setItem(DEADLINE_KEY, deadline);
    }
    function paint() {
      var left = Math.max(0, deadline - Date.now());
      var m = Math.floor(left / 60000);
      var s = Math.floor((left % 60000) / 1000);
      timerEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (left <= 0) { clearInterval(tick); tick = null; }
    }
    paint();
    tick = setInterval(paint, 1000);
  }

  render();
})();
